.button {
  width: 100%;
  margin-bottom: 24px;
}

.message {
  margin: 0;
}
